import React from 'react'
import * as Yup from 'yup'
import SumScoredQuestionnaireFields from './SumScoredQuestionnaireFields'
import { createSumScoredQuestionnaireSchema } from './createSumScoredQuestionnaireSchema'

const ASRM_QUESTIONS = [
  {
    key: 'ASRM_QUESTION_1',
    label: 'Positive mood',
  },
  {
    key: 'ASRM_QUESTION_2',
    label: 'Self-confidence',
  },
  {
    key: 'ASRM_QUESTION_3',
    label: 'Sleep patterns',
  },
  {
    key: 'ASRM_QUESTION_4',
    label: 'Speech',
  },
  {
    key: 'ASRM_QUESTION_5',
    label: 'Activity level',
  },
  {
    key: 'ASRM_SCORE',
    label: 'Score',
  },
]

export const ASRM_SCHEMA = createSumScoredQuestionnaireSchema('ASRM', 5, 4)

export type ASRMSchema = Yup.InferType<typeof ASRM_SCHEMA>

const ASRMFields = () => <SumScoredQuestionnaireFields type="ASRM" questions={ASRM_QUESTIONS} />

export default ASRMFields
